<template>
    <el-container style="height:86vh;">
      <el-container>
        <el-main>
         <appMain />
        </el-main>
      </el-container>
    </el-container>
</template>

<script>
import appMain from './components/appMain'

export default {
  name: 'Position',
  components: {
    appMain
  },
  data() {
    return {
      
    }
  },
  created () {
    
  },
  methods: {
     
  }
}
</script>

<style lang="less" scoped>
</style>
